import { endpoints } from "../config";
import { deleteData, getData, postData, putData } from "./api-utils";

export const getPdd = async () => {
  return await getData(endpoints.pdd);
};

export const getPddById = async (pddId) => {
  return await getData(`${endpoints.pdd}/${pddId}`);
};

export const postPdd = async (pddData) => {
  return await postData(endpoints.pdd, pddData);
};

export const updatePdd = async (pddId, pddData) => {
  return await putData(`${endpoints.pdd}/${pddId}`, pddData);
};

export const deletePdd = async (pddId) => {
  return await deleteData(`${endpoints.pdd}/${pddId}`);
};

export const getMediaTree = async () => {
  return await getData(endpoints.mediaTree);
};

export const getPddTheme = async () => {
  return await getData(endpoints.pddTheme);
};

export const postPddTheme = async (values) => {
  return await postData(endpoints.pddTheme, values);
};

export const updatePddTheme = async (values, id) => {
  return await putData(endpoints.pddTheme + "/" + id, values);
};

export const deletePddTheme = async (id) => {
  return await deleteData(endpoints.pddTheme + "/" + id);
};

export const postPddSubtheme = async (values) => {
  return await postData(endpoints.pddSubtheme, values);
};
